import React from "react";

import { StyledAvatar } from "./styles";
import { stringToHslColor } from "../../util";

const BaseAvatar = ({ name, userId }) => {
  if (name && userId) {
    const split = name.split(" ");
    const initials = split[0][0].toUpperCase() + split[1][0].toUpperCase();
    return <StyledAvatar bgcolor={stringToHslColor(userId)}>{initials}</StyledAvatar>;
  }
  return null;
};

export default BaseAvatar;
